/* eslint-disable */
<template>
  <div>
    <b-container v-if="this.type && item">
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
        v-translate
      >
        The Item has been updated
      </b-alert>
      <div class="my-3" v-if="model.editExtraActions" >
        <hr>
        <span v-for="(action, index) in model.editExtraActions" :key="index">
          <b-button
            :size="action.size || 'sm'"
            :variant="action.variant || 'primary'"
            @click="action.action(item)"
            :title="action.title || ''"
            style="padding: .5rem .65rem"
            class="mb-1"
            :disabled="(action.disabledCondition && action.disabledCondition(item))"
          >
            <font-awesome-icon v-if="action.icon" :icon="action.icon" size="2x" style="font-size: 16px;vertical-align: middle" />
            <span v-if="action.label">{{action.label}}</span>
          </b-button>
        </span>
        <hr>
      </div>
      <b-form @submit.prevent="patchItem">
        <div
          :id="'fieldsetHorizontal' + index"
          v-for="(field, index) in fields"
          :key="index"
          v-if="!field.hidden && ((field.key === 'id' && item[field.key]) || (field.key === 'external_id' && item[field.key]) || (field.key !== 'id' && field.key !== 'external_id'))"
        >
          <b-form-row
            class="mb-3"
            v-if="field.type !== Array"
          >
            <b-col sm="4" lg="3">
              <label id="fieldsetHorizontal__BV_label_" :for="'input-' + index" class="col-form-label">
                <strong v-if="field.required || (field.componentEdit ? fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).props.required : false)">
                  {{field.label || toTitleCase(field.key)}}
                  <span class="text-danger">*</span>
                </strong>
                <span v-else>
                  {{field.label || toTitleCase(field.key)}}
                </span>
              </label>
            </b-col>
            <b-col>
              <component :id="'input-' + index" v-model="item[field.key]" v-if="field.componentEdit" :is="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).is" v-b-tooltip.html v-bind="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).props" v-on="fields.find(x => x.key === field.key).componentEdit(item[field.key], field.key, item).on"></component>
              <b-row v-else-if="field.type === 'datetime' && item[field.key + 'DateTimeParts']">
                <b-col><b-form-input :id="'input-' + index" type="date" v-model="item[field.key + 'DateTimeParts'][0]" :required="field.required"></b-form-input></b-col>
                <b-col><b-form-input type="time" v-model="item[field.key + 'DateTimeParts'][1]" :required="field.required"></b-form-input></b-col>
              </b-row>
              <b-form-input :id="'input-' + index" v-else-if="field.type === 'date' && item[field.key + 'DateTimeParts']" type="date" v-model="item[field.key + 'DateTimeParts'][0]" :required="field.required" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" v-bind="field.props || void(0)" v-on="field.on || void(0)"></b-form-input>
              <b-form-input :id="'input-' + index" v-else-if="field.type === 'plainDate'" type="date" v-model="item[field.key]" :required="field.required" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" v-bind="field.props || void(0)" v-on="field.on || void(0)"></b-form-input>
              <b-form-select :id="'input-' + index" size="sm" v-model="item[field.key]" :options="[{value: true, text: 'Yes'}, {value: false, text: 'No'}]" :key="index" v-else-if="field.type === Boolean || field.type === 'boolean'" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" v-bind="field.props || void(0)" v-on="field.on || void(0)" />
              <b-form-select :id="'input-' + index" size="sm" v-model="item[field.key]" :options="[{value: 1, text: 'Yes'}, {value: 0, text: 'No'}]" :key="index" v-else-if="field.type === 'numericBoolean'" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" v-bind="field.props || void(0)" v-on="field.on || void(0)" />
              <b-form-select :id="'input-' + index" size="sm" v-model="item[field.key]" :options="setFieldOptions(field.options, field.withSelect)" v-else-if="field.type === 'select' && initialized" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" v-bind="field.props || void(0)" v-on="field.on || void(0)">
              </b-form-select>
              <b-form-textarea :id="'input-' + index" v-model="item[field.key]" v-else-if="field.type === 'textarea'" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" v-bind="field.props || void(0)" v-on="field.on || void(0)" />
              <span v-else-if="field.type === 'link'"><a :href="item[field.key]" target="_blank">{{item[field.key]}}</a></span>
              <b-form-input :id="'input-' + index" :type="field.type || 'text'" :step="field.type === 'time' && field.step ? field.step : null" v-model="item[field.key]" :disabled="!field.editable || (field.editCondition && !field.editCondition(item))" :required="field.required" v-bind="field.props || void(0)" v-on="field.on || void(0)" v-else />
              <small tabindex="-1" class="form-text text-muted" v-if="field.description" v-html="field.description"></small>
            </b-col>
          </b-form-row>
          <b-form-row v-else>
            <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label">{{field.label || toTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
            <b-form-input v-for="(subitem, i) in item[field.key]" v-model="item[field.key][i]" :key="i" class="mb-3" v-on="field.on || void(0)"></b-form-input>
          </b-form-row>
        </div>
        <b-form-row >
          <b-col cols="12" class="my-3">
            <hr>
          </b-col>
          <b-col>
            <b-button type="submit" variant="primary" v-translate>Submit</b-button>
          </b-col>
          <!-- HACK -->
          <b-col v-if="type === 'item-packs' && item.status === 'DRAFT' && item.items.length === 0" class="text-center">
            <b-button type="button" variant="warning" v-b-modal.modalPistolScan>Pistol Scan!</b-button>
            <b-modal id="modalPistolScan" ref="modalPistolScan" title="Start scanning" hide-footer @shown="$refs.packItemsTexarea.focus()" @hide="packItems = ''">
              <form @submit.stop.prevent="submitPackItems">
                <p :class="(packItems.match(/\n/g) || []).length !== item.quantity ? 'text-danger' : 'text-success'">Expected Items: <strong>{{item.quantity}}</strong><br>
                Currently Scanned Items: <strong>{{(packItems.match(/\n/g) || []).length}}</strong></p>
                <b-form-textarea
                  ref="packItemsTexarea"
                  v-model="packItems"
                  placeholder="Start scanning..."
                  :state="(packItems.match(/\n/g) || []).length === item.quantity"
                  rows="10"
                  :max-rows="item.quantity"

                ></b-form-textarea>
                <b-form-row>
                  <b-col cols="12" class="my-3">
                    <hr>
                  </b-col>
                  <b-col>
                    <b-button type="submit" variant="primary" :disabled="(packItems.match(/\n/g) || []).length !== item.quantity">Submit</b-button>
                  </b-col>
                  <b-col class="text-right" v-if="this.model.allowDelete">
                    <b-button @click.stop="$refs.modalPistolScan.hide()" variant="danger">Cancel</b-button>
                  </b-col>
                </b-form-row>
              </form>
            </b-modal>
          </b-col>
          <!-- /HACK -->
          <b-col class="text-right" v-if="this.model.allowDelete && (this.id || this.staticItem?.item?.id)">
            <b-button @click.stop="deleteItem" variant="danger" v-translate>DELETE Item</b-button>
          </b-col>
        </b-form-row>
      </b-form>
      <b-row v-if="model.showIncludes && model.includes && model.includes.length > 0">
        // eslint-disable-next-line
        <b-col v-for="(include, index) in model.includes" :key="index" v-if="item[include].length > 0">
          <hr>
          <api-list :type="include" :staticItems="item[include]" :title="toTitleCase(include)" :fields="models[include].fields" />
        </b-col>
      </b-row>
    </b-container>
    <div v-if="model.editBottomSlot">
      <!-- Edit Bottom Slot is defined at the Model -->
      <component
        :is="model.editBottomSlot"
        :ref="type + 'EditBottomSlot'"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiItemEdit',
  components: {
    ApiList: () => import('./ApiList') // hack for recursive component problem with name
  },
  props: {
    type: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    id: {
      type: [Number, String],
      required: false
    },
    staticItem: {
      type: Object,
      default: () => {}
    },
    clone: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      initialized: false,
      fields: [],
      item: {},
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      // HACK
      packItems: ''
    }
  },
  watch: {
    type: function () {
      this.fields = this.model.fields
    },
    staticItem(val) {
      console.log(val)
      this.item = { ...this.staticItem.item }
      this.setDateTimeParts()
    }
  },
  mounted() {
    console.log(this.model)
    this.fields = this.model.fields
    if (!this.staticItem && !this.clone && this.id) {
      this.getItem()
    } else if (this.staticItem) {
      console.log('XXXXXXXXXXXXX', this.staticItem)
      this.item = { ...this.staticItem.item }
      this.setDateTimeParts()
    } else {
      let item = {}
      for (let index = 0; index < this.model.fields.length; index++) {
        if (this.model.fields[index].type !== 'datetime' && this.model.fields[index].type !== 'date') {
          item = Object.assign(item, { [this.model.fields[index].key]: this.model.fields[index].default !== undefined ? this.model.fields[index].default : null })
        } else if (this.model.fields[index].type === 'datetime') {
          item = Object.assign(item, { [this.model.fields[index].key + 'DateTimeParts']: ['', '00:00:00'] })
        } else {
          item = Object.assign(item, { [this.model.fields[index].key + 'DateTimeParts']: ['', '23:59:59'] })
        }
      }
      this.item = item
    }
    this.init()
  },
  methods: {
    async init() {
      for (const field of this.fields) {
        if (field.options && !Array.isArray(field.options)) {
          await this['fetch' + field.options.charAt(0).toUpperCase() + field.options.slice(1)]()
        }
      }
      this.initialized = true
    },
    async getItem() {
      const params = {}
      if (this.model.includes) {
        params.includes = this.model.includes
      }
      await this.$http.get(this.model.endpoint + '/' + this.id, { params })
        .then(response => {
          this.item = response.body
          this.setDateTimeParts()
          this.$emit('item-loaded', this.item)
        })
    },
    setDateTimeParts() {
      for (const field of this.fields) {
        if (field.type === 'datetime' || field.type === 'date') {
          if (this.model.countrize || this.model.countrizeById) {
            this.$tz = window.countries.find(x => x.iso_code === this.item[this.model.countrize] || x.id === this.item[this.model.countrizeById]).front_config.i18n.tz
            this.moment.tz.setDefault(this.$tz)
            const watchCountryKey = 'item.' + (this.model.countrize || this.model.countrizeById)
            this.$watch(
              watchCountryKey,
              (val) => {
                this.$tz = window.countries.find(x => x.iso_code === val || x.id === val).front_config.i18n.tz
                this.moment.tz.setDefault(this.$tz)
              },
              {
                immediate: true
              }
            )
          }
          this.item[field.key + 'DateTimeParts'] = []
          this.item[field.key + 'DateTimeParts'][0] = this.moment.utc(this.item[field.key]).tz(this.$tz).format('YYYY-MM-DD')
          this.item[field.key + 'DateTimeParts'][1] = field.type !== 'date' ? this.moment.utc(this.item[field.key]).tz(this.$tz).format('HH:mm:ss') : '23:59:59'
        }
      }
      console.log(this.item)
    },
    patchItem() {
      let toPatch = {}
      for (const field in this.fields) {
        if (this.fields[field].editable || this.fields[field].forceSend) {
          toPatch[this.fields[field].key] = this.item[this.fields[field].key]
          if (this.fields[field].toLowerCase) {
            toPatch[this.fields[field].key] = toPatch[this.fields[field].key].toLowerCase()
          }
          if (this.fields[field].type === 'time' && !this.fields[field].withSeconds && this.item[this.fields[field].key].split(':').length === 3) {
            const timeParts = this.item[this.fields[field].key].split(':')
            toPatch[this.fields[field].key] = `${timeParts[0]}:${timeParts[1]}`
          }
          if (this.fields[field].type === 'datetime' || this.fields[field].type === 'date') {
            toPatch[this.fields[field].key] = this.moment.tz(this.item[this.fields[field].key + 'DateTimeParts'].join(' '), this.$tz).utc().format('YYYY-MM-DD HH:mm:ss')
            if (toPatch[this.fields[field].key] === 'Invalid date') {
              toPatch[this.fields[field].key] = null
            }
          }
        }
      }
      console.log(toPatch)
      if (this.id || this.staticItem?.item?.id) {
        if (this.model.beforeEditAction) {
          this.model.beforeEditAction(toPatch)
        }
        if (this.model.beforeEditFilter) {
          toPatch = this.model.beforeEditFilter(toPatch)
        }
        this.$http.patch(this.model.endpoint + '/' + (this.id || this.staticItem.item.id), toPatch)
          .then(response => {
            this.showAlert()
            if (!this.staticItem) {
              if (this.model.afterEditAction) {
                this.model.afterEditAction(response.body)
              } else {
                this.getItem()
              }
              this.$emit('success', this.staticItem)
            } else {
              this.$emit('success', this.staticItem)
            }
          })
      } else {
        if (this.model.beforeCreateAction) {
          this.model.beforeCreateAction(toPatch)
        }
        if (this.model.beforeCreateFilter) {
          toPatch = this.model.beforeCreateFilter(toPatch)
        }
        this.$http.post(this.model.endpoint, toPatch)
          .then(response => {
            this.showAlert()
            console.log(response.body)
            this.item = response.body
            // if (!this.staticItem) {
            //   this.getItem()
            // } else {
            //   this.$emit('success', this.staticItem)
            // }
            if (this.model.afterCreateAction) {
              this.model.afterCreateAction(response.body)
            }
            this.$emit('success', this.staticItem)
          })
      }
    },
    deleteItem() {
      if (
        confirm('Are you sure you want to DELETE the row with ID:\n' + this.id + '\nWARNING: THIS ACTION CANNOT BE UNDONE!')
      ) {
        const endpoint = this.model.endpointDelete ? this.model.endpointDelete.replace('{id}', this.id) : this.model.endpoint + '/' + this.id
        this.$http.delete(this.$appConfig.api.baseUrl + endpoint)
          .then(() => {
            this.$router.push('/list/' + this.model.endpoint, { query: { deleted: true } })
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    // HACK
    submitPackItems() {
      const items = this.packItems.split('\n').filter(Boolean)
      const dupes = this.checkDuplicates(items)
      if (dupes) {
        const mssg = '<p>You have scanned DUPLICATED items. Please, REVIEW the serial numbers carefully: </p><ul class="text-left">' + dupes + '</ul>'
        const obj = {
          title: 'ERROR',
          message: mssg,
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      } else {
        const payload = {
          items: items.map(x => {
            return {
              description: this.item.reference,
              serial_number: x,
              quantity: 1
            }
          })
        }
        this.$http.patch(this.$appConfig.api.baseUrl + 'warehouse/' + this.$store.getters.profile.id + '/item-packs/' + this.item.id + '/items', payload)
          .then(() => {
            this.$refs.modalPistolScan.hide()
            this.getItem()
          })
      }
    },
    checkDuplicates(array) {
      const counts = {}
      let mssg = ''

      for (const item of array) {
        if (counts[item]) {
          counts[item] += 1
        } else {
          counts[item] = 1
        }
      }
      for (const prop in counts) {
        if (counts[prop] >= 2) {
          mssg += '<li>' + prop + ': ' + counts[prop] + ' times</li>'
        }
      }
      if (mssg) {
        return mssg
      } else {
        return false
      }
    },
    setFieldOptions(fetch, options = false) {
      if (!Array.isArray(fetch)) {
        if (fetch === 'shippingStatusReasons') {
          return Object.entries(this.shippingStatusReasons).reduce((a, [key, value]) => (
            a.concat(value.map(y => {
              return {
                text: key + ' - ' + y.name,
                value: y.reason_id
              }
            }))
          ), [])
        } else {
          if (!options) {
            return this[fetch]
          } else {
            return this[fetch + 'Select']
          }
        }
      } else {
        return fetch
      }
    }
  }
}
</script>
